export default function showSnackBar(message, type, context) {
    context.props.enqueueSnackbar(`${message}`, {
        variant: `${type}`, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }
    });
}